import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	all: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	switchToJql: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	messageToCustomer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	all: {
		id: 'jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.all',
		defaultMessage: 'All',
		description:
			'In the button trigger this indicates that the user added a JQL clause but have not set any RHS values',
	},
	switchToJql: {
		id: 'jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.switch-to-jql',
		defaultMessage: 'Switch to JQL',
		description: 'A button trigger that lets the user switch to Advanced JQL Builder',
	},
	messageToCustomer: {
		id: 'jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.message-to-customer',
		defaultMessage: 'To search by <b>{fieldLabel}</b>.',
		description: 'Tell user that this field is not supported in basic mode',
	},
});
export default messages;
